<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12">
                <v-card flat outlined>
                    <v-card-text>
                        <v-row>
                            <v-col>
                                <v-data-table
                                    :headers="headers"
                                    :items="items"
                                    fixed-header
                                    dense
                                    class="row-item"
                                    :items-per-page="-1"
                                    :hide-default-footer="true"
                                    :height="400"
                                    :no-data-text="$t('labels.noData')"
                                >
                                    <template v-slot:item="row">
                                        <tr
                                            :class="{'cursor-pointer': true}"
                                            @contextmenu.prevent="editClick(row.item.id)"
                                        >
                                            <td @click="editClick(row.item.id)">
                                                {{ row.item.name }}
                                            </td>
                                            <td @click="editClick(row.item.id)">
                                                {{ row.item.date_modified }}
                                            </td>
                                            <td @click="editClick(row.item.id)">
                                                {{ row.item.user_display }}
                                            </td>
                                        </tr></template
                                    ></v-data-table
                                >
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row>
            <v-dialog persistent v-model="editTemplate" width="600">
                <v-card>
                    <v-card-title>
                        {{ template.name }}
                    </v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12">
                                <v-row dense wrap>
                                    <v-col cols="12" md="6" class="text-left">
                                        <v-col cols="12">
                                            <Upload :readonly="false" v-model="template.uploaded_file"></Upload>
                                        </v-col>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col
                                cols="12"
                                md="6"
                                class="text-right"
                                :class="{'text-center': $vuetify.breakpoint.smAndDown}"
                            >
                                <v-btn color="primary" class="white--text" @click.stop="saveChanges"
                                    >{{ $t('buttons.save') }}
                                </v-btn>
                            </v-col>
                            <v-col
                                cols="12"
                                md="6"
                                class="text-left"
                                :class="{'text-center': $vuetify.breakpoint.smAndDown}"
                            >
                                <v-btn color="secondary" class="white--text" @click.stop="closeDialog"
                                    >{{ $t('buttons.cancel') }}
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </v-row>
    </v-container>
</template>

<script>
import ContractTemplate from '../models/ContractTemplate';
import Upload from './trinkets/Upload.vue';
export default {
    name: 'ContractTemplates',
    components: {Upload},
    data: function () {
        return {
            template: new ContractTemplate({}),
            selectedHeaders: [],
            headers: [
                {text: this.$t('fields.template'), sortable: false},
                {text: this.$t('fields.dateModified'), sortable: false},
                {text: this.$t('fields.modifiedBy'), sortable: false},
                {text: '', value: 'actions', type: '', sortable: false, allowFilter: false},
            ],
            lastRequest: null,
            items: [],
            total: 0,
            editTemplate: false,
        };
    },
    watch: {
        'template.uploaded_file': {
            handler: function () {
                if (this.template.uploaded_file.name != '') {
                    var ext = this.template.uploaded_file.original_name.split('.').pop();
                    if (!(ext == 'docx' || ext == 'doc')) {
                        this.template.uploaded_file.name = '';
                        this.template.uploaded_file.link = '';
                        this.template.uploaded_file.original_name = '';
                        this.template.uploaded_file.upload_id = null;
                        this.$alert(this.$t('alerts.onlyDocx'));
                    }
                }
            },
            deep: true,
        },
    },
    methods: {
        closeDialog() {
            this.editTemplate = false;
            this.template = new ContractTemplate({});
        },

        editClick(id) {
            let vm = this;
            this.template.id = id;
            this.$APICall(
                'get',
                'contract-templates/' + this.template.id,
                this.lastRequest,
                (data, success) => {
                    if (success) {
                        vm.template = data;
                    } else {
                        vm.$alert(vm.$t('alerts.basicError'));
                    }
                },
                false,
            );
            this.editTemplate = true;
        },
        reloadData() {
            let vm = this;
            this.$APICall('get', 'contract-templates-all', this.lastRequest, (data, success) => {
                if (success) {
                    vm.items = data;
                } else {
                    vm.$alert(vm.$t('alerts.basicError'));
                }
            });
        },
        saveChanges() {
            let vm = this;
            let succes = true;
            // if (this.template.uploaded_file.name == '') {
            //     succes = false;
            // }
            this.template.user_id = this.$myStore.state.user.id;

            if (succes) {
                this.$APICall('put', 'contract-templates/' + vm.template.id, vm.template, (data, succes) => {
                    if (succes) {
                        vm.reloadData();
                        vm.$notify(vm.$t('alerts.basicUpdate'));
                        vm.closeDialog();
                    } else {
                        vm.$alert(vm.$t('alerts.basicError'));
                    }
                });
            } else {
                // vm.$alert(vm.$t('alerts.missingDocument'));
            }
        },
    },
    mounted() {
        this.reloadData();
    },
};
</script>

<style scoped></style>
